// client/src/App.js
import React, { lazy, Suspense, memo } from 'react';
import { BrowserRouter, Routes, Route} from 'react-router-dom';

import Navbar from './navbar';
import Footer from './footer';
import GAListener from './GAListener';

const HomePage = lazy(() => import('./home'));
const AboutPage = lazy(() => import('./about'));
const ContactPage = lazy(() => import('./contact'));
const PageNotFound = lazy(() => import('./404'));
const DonationThankYouPage = lazy(() => import('./thankYouPage'));

// Javascript and Browser Internals
const JavascriptAndBrowserInternalsArticles = lazy(() => import("./web/JavaScript and Browser Internals/JavascriptAndBrowserInternalsArticles"));
const JavascriptMemoryManagement = lazy(() => import("./web/JavaScript and Browser Internals/Topics/JavascriptMemoryManagement"));

// Security Testing Tools
const SecurityTestingToolsArticles = lazy(() => import("./web/Security Testing Tools/SecurityTestingToolsArticles"))
const ConfigureBurpWithChromeAndFirefox = lazy(() => import("./web/Security Testing Tools/Topics/ConfigureBurpWithBrowsers"));

// Common Security Vulnerabilities
const WebVulnerabilitiesArticles = lazy(() => import("./web/Web Vulnerabilities/WebVulnerabilitiesArticles"));
const DomXss = lazy(() => import("./web/Web Vulnerabilities/Topics/DomXss"))

// Information Gathering
const AdvancedSearchOperatorsArticles = lazy(() => import("./web/Information Gathering/InformationGatheringArticles"))
const AdvancedSearchOperators = lazy(() => import("./web/Information Gathering/Topics/AdvancedSearchOperators"))

// Web Security Methodology
const WebSecurityMethodologyArticles = lazy(() => import("./web/Web Security Methodology/WebSecurityMethodologyArticle"))
const AuthenticationFlowAnalysis = lazy(() => import("./web/Web Security Methodology/Topics/AuthenticationFlowAnalysis"))

const App = () => (
  <BrowserRouter>
    <GAListener />
    <Suspense fallback={<div>Please Wait...</div>}>
      <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        <Navbar />
        <div style={{ flex: 1 }}>
          <Routes>
            <Route path='/' element={<HomePage />} />
            <Route path='/about' element={<AboutPage />} />
            <Route path='/contact' element={<ContactPage />} />
            <Route path="/donation-thank-you" element={<DonationThankYouPage />} />

            {/* Javascript and Browser Internals */}
            <Route path="/javascript-browser" element={<JavascriptAndBrowserInternalsArticles />} />
            <Route path="/javascript-browser/Javascript-memory-management" element={<JavascriptMemoryManagement />} />

            {/* Security Testing Tools */}
            <Route path="/security-tools/" element={<SecurityTestingToolsArticles />} />
            <Route path="/security-tools/configure-burp-with-chrome-and-firefox" element={<ConfigureBurpWithChromeAndFirefox />} />

            {/* Common Security Vulnerabilites */}
            <Route path="/web-vulnerabilites/" element={<WebVulnerabilitiesArticles />} />
            <Route path="/web-vulnerabilites/dom-xss" element={<DomXss />} />

            {/* Information gathering */}
            <Route path="/information-gathering/" element={<AdvancedSearchOperatorsArticles />} />
            <Route path="/information-gathering/advanced-search-operators" element={<AdvancedSearchOperators />} />

            {/* Web Security Methodology */}
            <Route path="/web-security-methodology/" element={<WebSecurityMethodologyArticles />} />
            <Route path="/web-security-methodology/authentication-flow-analysis" element={<AuthenticationFlowAnalysis />} />
            
            {/* Catch-all for 404 */}
            <Route path='*' element={<PageNotFound />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Suspense>
  </BrowserRouter>
);

export default memo(App);
